import PropTypes from "prop-types"
import { MenuItem } from "@mui/material"
import { Controller } from "react-hook-form"
import DropdownCommon from "./DropdownCommon"

const Dropdown = ({ control, label, name, onValueChange, options, ...rest }) => {

  const renderOptions = (options, native) => {
    const optionsList = options.map((option) => {
      if (native) {
        return (
          <option
            data-field={name}
            data-testid={`${name}-option-${option.value}`}
            data-value={option.value}
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        )
      }

      return (
        <MenuItem
          data-field={name}
          data-testid={`${name}-option-${option.value}`}
          data-value={option.value}
          key={option.value}
          value={option.value}
        >
          {option.label}
        </MenuItem>
      )
    })

    if (native && !rest.multiple) {
      return [<option key="empty-option" value="" />, ...optionsList]
    }

    return optionsList
  }

  return (
    <Controller
      control={control}
      label={label}
      name={name}
      render={({
        field: { onChange, value },
        fieldState: { error }
      }) => (
        <DropdownCommon
          {...rest}
          error={error}
          label={label}
          name={name}
          onChange={(event) => {
            const selectedValue = event.target.value
            onChange(selectedValue)
            if (onValueChange) {
              onValueChange(selectedValue)
            }
          }}
          renderOptions={renderOptions(options, !!rest.native)}
          value={value}
        />
      )}
    />
  )
}

Dropdown.propTypes = {
  control: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  native: PropTypes.bool,
  options: PropTypes.array.isRequired
}

export default Dropdown
